var _circle, _path, _rect, _line, _line2, _line3, _line4, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48.5,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 22.5,
    r: 22.5,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "inner-circle",
    d: "M36.4499 35.4499C33.0154 38.8844 28.3572 40.8139 23.5 40.8139C18.6428 40.8139 13.9846 38.8844 10.5501 35.4499C7.11554 32.0154 5.18604 27.3571 5.18604 22.5C5.18604 17.6428 7.11554 12.9846 10.5501 9.55007C13.9846 6.11554 18.6428 4.18604 23.5 4.18604C28.3572 4.18604 33.0154 6.11554 36.4499 9.55007C39.8844 12.9846 41.8139 17.6428 41.8139 22.5C41.8139 27.3571 39.8844 32.0154 36.4499 35.4499Z",
    fill: "#F97953"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "refresh-icon",
    x: 12.7755,
    y: 21.9563,
    width: 12.1122,
    height: 12.1122,
    rx: 1.27375,
    stroke: "#1E1E1E",
    strokeWidth: 0.931713
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "refresh-icon",
    x1: 21.1406,
    y1: 21.9561,
    x2: 21.1406,
    y2: 34.0682,
    stroke: "#1E1E1E",
    strokeWidth: 0.931713
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "refresh-icon",
    x1: 16.9276,
    y1: 21.9561,
    x2: 16.9276,
    y2: 34.0682,
    stroke: "#1E1E1E",
    strokeWidth: 0.931713
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "refresh-icon",
    x1: 24.8877,
    y1: 26.1084,
    x2: 12.7755,
    y2: 26.1084,
    stroke: "#1E1E1E",
    strokeWidth: 0.931713
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "refresh-icon",
    x1: 24.8877,
    y1: 30.3211,
    x2: 12.7755,
    y2: 30.3211,
    stroke: "#1E1E1E",
    strokeWidth: 0.931713
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "refresh-icon",
    d: "M23.5016 33.1782C23.5016 34.6403 24.7261 35.9683 26.3267 35.7212C28.2577 35.4231 30.1093 34.7111 31.7486 33.6248C33.9683 32.1539 35.6993 30.0625 36.7217 27.6145C37.7442 25.1665 38.0118 22.4723 37.4905 19.873C36.9692 17.2738 35.6825 14.8871 33.7943 13.0144C31.9061 11.1418 29.5011 9.86719 26.8839 9.35087C24.2666 8.83457 21.5537 9.0995 19.0879 10.1124C16.6221 11.1254 14.5135 12.8412 13.0296 15.0438C12.0161 16.548 11.3251 18.2331 10.9888 19.9947L10.1383 19.1416C9.73412 18.7362 9.18507 18.5093 8.61312 18.5078C8.04137 18.5062 7.49106 18.7298 7.08277 19.1302C6.67429 19.5308 6.44028 20.0768 6.43538 20.6495C6.43048 21.2223 6.65542 21.7723 7.05983 22.1779L12.0157 27.1486C12.4199 27.554 12.969 27.7808 13.5409 27.7824C14.1127 27.784 14.663 27.5604 15.0713 27.16L20.1119 22.2169C20.5204 21.8164 20.7544 21.2703 20.7593 20.6976C20.7642 20.1248 20.5393 19.5748 20.1348 19.1692C19.7306 18.7638 19.1816 18.5369 18.6096 18.5353C18.0379 18.5337 17.4876 18.7573 17.0793 19.1577L16.8049 19.4268C17.0054 18.9477 17.2535 18.4867 17.547 18.0511C18.4321 16.7374 19.6907 15.7126 21.1645 15.1071C22.6383 14.5017 24.2605 14.3432 25.8255 14.6519C27.3905 14.9606 28.8272 15.7225 29.9542 16.8403C31.0812 17.958 31.8479 19.3812 32.1585 20.9297C32.4691 22.4782 32.3098 24.0833 31.7004 25.5423C31.091 27.0014 30.0586 28.2495 28.7328 29.128C27.9092 29.6738 26.9955 30.0616 26.0389 30.2772C24.7422 30.5693 23.5016 31.6515 23.5016 33.1782Z",
    fill: "#1E1E1E",
    stroke: "#F97953",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Refresh.0bcdabe096b836f99168ba18159f9337.svg";